/* ==================================================
  お届け希望日時の指定切替

  配送日時指定アプリ（AMP）の入力欄は、チェックを入れたときだけ表示する。
  表示/非表示は CSS（c_main-cart.css）が担当し、このスクリプトは
  カート属性の整合だけを受け持つ。

  - チェックON  … delivery_request = 'yes'
  - チェックOFF … アプリの入力欄を初期化し、delivery_request とアプリ側の属性を消す

  外したときは郵便番号とプルダウンを初期化する。
  郵便番号を空にするとアプリ側が「お届け希望日」ごと初期状態へ戻すため、
  画面の表示とカート属性が食い違わない（リロードは不要）

  アプリはカートページを開くたびに「配送日の指定: なし」「配送時間帯: 指定なし」を
  無条件で書き戻す（入力欄が非表示でも起きる）。
  そのため読み込み時に消しても再び付くので、注文に載せないための最後の砦として
  購入手続きの直前にも消す
===================================================*/
(() => {
  'use strict';

  /*  アプリが書き込むカート属性。空文字を送ると属性ごと削除される  */
  const APP_ATTRIBUTE_KEYS = ['配送日の指定', '配送希望日', '配送時間帯', '置き配の利用', 'チャイム'];
  const OWN_ATTRIBUTE_KEY = 'delivery_request';

  /*  アプリが入力済みの住所を保存しておく localStorage キー（再読込時に郵便番号を復元する）  */
  const APP_ADDRESS_STORAGE_KEY = 'cart-delivery-datetime__address';

  /*  アプリの描画完了まで操作させない要素（チェック行・購入手続きボタン）  */
  const LOCKABLE_SELECTOR = '[data-delivery-lockable]';
  const PENDING_SELECTOR = '[data-delivery-pending]';
  const APP_READY_SELECTOR = '.delivery-container';
  const APP_READY_TIMEOUT = 10000;

  const toggle = document.querySelector('[data-delivery-request-toggle]');
  if (!toggle) return;

  /* ------------------------------
    アプリの描画待ち

    配送日時指定アプリはUIをJSで描画するため、描画が終わるまで
    「お届け希望日時を指定する」も「購入手続きへ」も押せないようにする。

    ロックはこのスクリプトが付けて、このスクリプトが外す。
    Liquid側で最初からロックした状態で描画すると、
    このスクリプトが読み込めなかったときに永久に開けなくなる。
    アプリが落ちている場合も購入できなくならないよう、一定時間で解除する
  ------------------------------*/
  function lockPending() {
    document.querySelectorAll(LOCKABLE_SELECTOR).forEach((element) => {
      element.setAttribute('data-delivery-pending', '');

      if (element.tagName === 'BUTTON') {
        element.setAttribute('aria-disabled', 'true');
      }

      const input = element.querySelector('input');
      if (input) input.disabled = true;
    });
  }

  function releasePending() {
    document.querySelectorAll(PENDING_SELECTOR).forEach((element) => {
      element.removeAttribute('data-delivery-pending');
      element.removeAttribute('aria-disabled');

      const input = element.querySelector('input');
      if (input) input.disabled = false;
    });
  }

  function isPending() {
    return Boolean(document.querySelector(PENDING_SELECTOR));
  }

  if (document.querySelector(APP_READY_SELECTOR)) {
    /*  すでに描画済みならロックしない  */
  } else if (document.querySelector(LOCKABLE_SELECTOR)) {
    lockPending();

    const observer = new MutationObserver(() => {
      if (!document.querySelector(APP_READY_SELECTOR)) return;
      observer.disconnect();
      releasePending();
    });

    observer.observe(document.body, { childList: true, subtree: true });

    window.setTimeout(() => {
      if (!isPending()) return;
      observer.disconnect();
      releasePending();
      console.warn('[c_cart-delivery-request]', '配送日時指定アプリの描画を待たずに解除しました');
    }, APP_READY_TIMEOUT);
  }

  function clearedAttributes() {
    const attributes = {};
    attributes[OWN_ATTRIBUTE_KEY] = '';
    APP_ATTRIBUTE_KEYS.forEach((key) => {
      attributes[key] = '';
    });
    return attributes;
  }

  function updateAttributes(attributes) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    }).catch((error) => {
      console.error('[c_cart-delivery-request]', 'update failed', error);
    });
  }

  /* ------------------------------
    アプリの入力欄の初期化

    郵便番号を空にすると、アプリが「お届け希望日」の欄ごと初期状態に戻す。
    値の書き換えはネイティブの setter 経由で行う（アプリ側の実装が
    プロパティ代入を検知できるようにするため）。

    アプリは入力した住所を localStorage に保存して次回以降に復元するため、
    そちらも消さないと再読込で郵便番号が戻ってしまう
  ------------------------------*/
  function resetAppFields() {
    try {
      localStorage.removeItem(APP_ADDRESS_STORAGE_KEY);
    } catch (error) {
      /*  プライベートモード等で localStorage が使えない場合は無視する  */
    }

    const box = document.querySelector('.delivery_box');
    if (!box) return;

    const zip = box.querySelector('.amp-text__field input[type="tel"]');

    if (zip && zip.value) {
      const setValue = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
      setValue.call(zip, '');
      zip.dispatchEvent(new Event('input', { bubbles: true }));
      zip.dispatchEvent(new Event('change', { bubbles: true }));
    }

    box.querySelectorAll('select').forEach((select) => {
      if (!select.options.length) return;

      const defaultValue = select.options[0].value;
      if (select.value === defaultValue) return;

      select.value = defaultValue;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ------------------------------
    チェックの切り替え

    リロードは挟まない。入力欄を初期化してから属性を消すので、
    入れ直したときも画面は未入力の状態で揃う
  ------------------------------*/
  toggle.addEventListener('change', async () => {
    if (toggle.checked) {
      await updateAttributes({ [OWN_ATTRIBUTE_KEY]: 'yes' });
      return;
    }

    resetAppFields();

    /*  初期化に反応したアプリ側の書き込みが後から届いて属性が復活しないよう、少し待つ  */
    await new Promise((resolve) => setTimeout(resolve, 400));
    await updateAttributes(clearedAttributes());
  });

  /* ------------------------------
    購入手続き直前の掃除

    チェックが入っていなければ、アプリが書き戻した属性を消してから送信する。
    注文に「指定していない配送日時」が載るのを防ぐ。
    カートページのフォームだけでなく、ミニカート（ドロワー）からの決済も拾う
  ------------------------------*/
  let submitting = false;

  document.addEventListener(
    'submit',
    async (event) => {
      const form = event.target;
      if (!form || !form.querySelector || !form.querySelector('[name="checkout"]')) return;

      /*  描画待ちの間はキーボード操作などでも送信させない（カートページのフォームのみ）  */
      if (form.classList.contains('cart__recap') && isPending()) {
        event.preventDefault();
        return;
      }

      if (submitting || toggle.checked) return;

      event.preventDefault();
      await updateAttributes(clearedAttributes());

      submitting = true;
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(event.submitter);
      } else {
        form.submit();
      }
    },
    true
  );

  /* ------------------------------
    チェックが無いのに実際の指定が残っている場合の掃除

    この機能を入れる前のカートなどで起きる。
    アプリ既定値（なし／指定なし）は毎回書き戻されるため対象にしない。
    対象にすると読み込みのたびに無駄な通信が走る
  ------------------------------*/
  (async () => {
    if (toggle.checked) return;
    if (!document.querySelector('.c_app-block[data-delivery-selection]')) return;

    await updateAttributes(clearedAttributes());
  })();
})();
